<!--Steam登录弹框-->
<template>
  <div class="steam">
    <!--    <div id="telegram-login" class="telegram-login"></div>-->
    <myModal class="steam-login" :visible="visible" centered @close="close($event)">
      <template #cuscloseIcon>
        <img src="@/assets/images/index/loginclose.png" alt="" />
      </template>
      <template #mytitle>
        <div>{{ localTitle }}</div>
      </template>
      <template #body>
        <div class="def-login" v-if="localContentType == 'def'">
          <div class="options">
            <a-button class="email-btn cbtn-def" @click="doLogin('emailver', $event)">
              <template #icon>
                <img
                  class="btn-icon"
                  src="@/assets/images/index/login_email.svg"
                  alt=""
                />
                <span class="btn-txt">{{ $t("emailLogin") }}</span>
              </template>
            </a-button>
            <a-button class="stean-btn cbtn-def" @click="doLogin('steam', $event)">
              <template #icon>
                <img
                  class="btn-icon"
                  src="@/assets/images/index/login_steam.png"
                  alt=""
                />
                <span class="btn-txt">{{ $t("steamLogin") }}</span>
              </template>
            </a-button>
            <a-button class="discord-btn cbtn-def" @click="doLogin('discord', $event)">
              <template #icon>
                <img
                  class="btn-icon"
                  src="@/assets/images/index/login_discord.svg"
                  alt=""
                />
                <span class="btn-txt">{{ $t("discordLogin") }}</span>
              </template>
            </a-button>
            <a-button class="telegram-btn cbtn-def" @click="doLogin('telegram', $event)">
              <div class="wrapper">
                <img
                  class="btn-icon"
                  src="@/assets/images/index/login_telegram.svg"
                  alt=""
                />
                <span class="btn-txt">{{ $t("telegramLogin") }}</span>
              </div>
              <template #icon>
                <!--                <img-->
                <!--                    class="btn-icon"-->
                <!--                    src="@/assets/images/index/login_telegram.svg"-->
                <!--                    alt=""-->
                <!--                />-->
                <!--                <span class="btn-txt">{{ $t("telegramLogin") }}</span>-->
                <!--                <telegramAuth v-if="showTeleVisible" size="large"></telegramAuth>-->
              </template>
            </a-button>
            <a-button
              v-if="0"
              class="stean-btn cbtn-def cbtn-blue"
              @click="doLogin('email', $event)"
            >
              <template #icon>
                <img
                  class="btn-icon"
                  src="@/assets/images/index/login_telegram.svg"
                  alt=""
                />
                <span class="btn-txt">{{ $t("emailLogin") }}</span>
              </template>
            </a-button>
          </div>
          <div class="l-w agreement">
            <div class="d2">
              <a-checkbox v-model:checked="term1">
                <!-- {{ $t("isAgree",{servicePolicy: $t("servicePolicy")}) }} -->
                <i18n-t keypath="isAgree" tag="false">
                  <template #servicePolicy>
                    <span @click="toPolicy(4)" class="policy">{{
                      $t("varServicePolicy")
                    }}</span>
                  </template>
                  <template #privacyPolicy>
                    <span @click="toPolicy(5)" class="policy">{{
                      $t("varPrivacyPolicy")
                    }}</span>
                  </template>
                  <template #cardholderPolicy>
                    <span @click="toPolicy(7)" class="policy">{{
                      $t("varCardHolderPolicy")
                    }}</span>
                  </template>
                </i18n-t>

                <!-- <span>{{ $t('serviceInfo')+',' }}</span>
                <span>{{ $t('privacyInfo')+',' }}</span>
                <span>{{ $t('privacyInfo')+',' }}</span> -->
              </a-checkbox>
              <a-checkbox v-model:checked="term2">
                {{ $t("already18") }}
              </a-checkbox>
            </div>
          </div>
          <!--                              <template v-if="isTest">-->
          <!--                                <div class="devlogin">-->
<!--                                            <div class="test" @click="testLogin">密码登录</div>-->
<!--          <div class="test" @click="testLogin2">密码登录163</div>-->
          <!--                                </div>-->
          <!--                              </template>-->
        </div>
      </template>
    </myModal>
  </div>

  <div>
    <!-- Terms of Service  servicePolicy -->
    <!-- Privacy Policy  privacyPolicy -->
    <!-- Cardholder Agreement  cardholderPolicy -->

    <!-- I agree with the {servicePolicy}, {privacyPolicy}, and {cardholderPolicy} -->
    <!-- 本人同意{servicePolicy}、{privacyPolicy}及{cardholderPolicy}。 -->
  </div>
</template>

<script setup>
import {
  ref,
  reactive,
  toRaw,
  computed,
  nextTick,
  onMounted,
  getCurrentInstance,
} from "vue";
import showNotice from "@/components/common/notice/notice.js";
import $api from "@/api/index.js";
import $store from "@/store";
import { Form, message } from "ant-design-vue";
import handleResponse from "@/utils/handleResponseData.js";
import i18n from "@/i18n";
import { showRechargeRebateModal } from "@/utils/auth.js";
// import telegramAuth from "@/components/common/telegramAuth/telegramAuth.vue";
const { t: $t, locale } = i18n.global;
import { useRoute, useRouter } from "vue-router";
import eventEmitter from "@/utils/emitter.js";

const { proxy } = getCurrentInstance();
const route = useRoute(); // 获取当前路由
const useForm = Form.useForm;
const router = useRouter();

function testServicePolicy() {
  console.log("to service policy");
  router.push("policy/4");
}

const userStore = $store("user");
const isTest = import.meta.env.VITE_SHOW_TESTPAGE === "true";

const props = defineProps({
  visible: {
    type: Boolean,
    desc: "登录弹框开关",
    default: false,
  },
  title: {
    type: String,
    desc: "登录弹框标题",
    default: "steam 登录",
  },
  contentType: {
    type: String,
    desc: "登录弹框,可选值为 def  reg  reset  email",
    default: "",
  },
});

//登录弹框内容类型 def-默认  reg-注册/找回密码页 email-邮箱验证码/密码登录页
const localContentType = ref(props.contentType);
//弹框标题
const localTitle = ref(props.title);
const emits = defineEmits(["close", "login", "reg", "rest", "email", "click"]);
const term1 = ref(false); //协议
const term2 = ref(false); //是否成年

//是否同意协议
function permit() {
  if (term1.value && term2.value) {
    return true;
  }
  showNotice("f", { desc: $t("requireAccept") });
  return false;
}

function toFAQ() {
  console.log("to FAQ");
}

function doLogin(type, e) {
  if (!permit()) {
    return;
  }
  // console.log("param:", type, e);
  e.stopPropagation();
  //通过steam登录
  if ("steam" == type) {
    // console.log("steam login");
    //获取当前页面路由
    // 创建 URL 对象
    const url = new URL(window.location.href);
    // 获取当前页面的路径
    const currentPath = url.pathname;
    console.log("currentUrl:", currentPath);
    localStorage.setItem("currentPath", currentPath);
    userStore.from = currentPath;
    steamLogin();
  }
  if ("emailver" == type) {
    console.log("email verify or login");
    //弹框-邮箱注册登录弹框
    eventEmitter.emit("api:emailVerifyLogin");
    emits("close");
    //邮箱验证码注册/登录
    // emailVerifyLogin();
  }
  if ("discord" == type) {
    console.log("discord login");
    //获取当前页面路由
    // 创建 URL 对象
    const url = new URL(window.location.href);
    // 获取当前页面的路径
    const currentPath = url.pathname;
    console.log("currentUrl:", currentPath);
    localStorage.setItem("currentPath", currentPath);
    userStore.from = currentPath;
    discordLogin();
  }
  if ("telegram" == type) {
    console.log("telegram login");

    //弹框-飞机登录弹框==飞机登录注册改为跟discord一样的逻辑
    // eventEmitter.emit("api:telegramLogin");
    // emits("close");

    //飞机登录注册==跟discord一样的逻辑
    //获取当前页面路由
    // 创建 URL 对象
    const url = new URL(window.location.href);
    // 获取当前页面的路径
    const currentPath = url.pathname;
    console.log("currentUrl:", currentPath);
    localStorage.setItem("currentPath", currentPath);
    userStore.from = currentPath;
    telegramLogin();

    return;
    console.log("用户id;", userStore.userInfo.id);
    const userid = userStore.userInfo.id;
    // 动态加载 Telegram 脚本
    const script = document.createElement("script");
    script.src = "https://telegram.org/js/telegram-widget.js?22";
    script.async = true;

    // 设置 widget 属性
    script.setAttribute("data-telegram-login", "skinroll_bot"); // 替换你的机器人用户名skintest_impayBot
    console.log("size;", "medium");
    script.setAttribute("data-size", "medium"); //medium small large
    script.setAttribute("data-radius", "14");
    script.setAttribute(
      "data-auth-url",
      "https://backskins.hotgamer.net/telegram/auth?p=60001&u=" + userid
    ); // 替换你的后端验证URL
    script.setAttribute("data-request-access", "write");

    script.addEventListener("load", () => {
      console.log("脚本加载完毕");
      // emits("rendered");
      const iframe = document.getElementById("telegram-login-skintest_impayBot");
      // emits("rendered");
      // 处理兼容行问题 兼容IE
      if (iframe.attachEvent) {
        iframe.attachEvent("onload", function () {
          // iframe加载完毕以后执行操作
          console.log("iframe已加载完毕");
          // container.innerHTML = "";
          emits("rendered");
        });
      } else {
        iframe.onload = function () {
          // iframe加载完毕以后执行操作
          console.log("iframe已加载完毕");
          // container.innerHTML = "";
          emits("rendered");
        };
      }
    });
    // 将脚本添加到容器中
    const container = document.getElementById("telegram-login");
    container.appendChild(script);
    console.log("tele 渲染完毕");
  }
}

//discord注册登录
function discordLogin() {
  console.log("discord login");
  const params = {
    invite: null,
    client_id: localStorage.getItem('ga4_client_id')
  };
  const invite_id = localStorage.getItem("invite_id");
  if (invite_id) {
    params.invite = invite_id;
  }
  if (params.invite) {
    console.log("有邀请码");
    $api.user.discordLogin({ params: params }).then((res) => {
      console.log("discord res url;", res);
      window.location.href = res.url;
    });
  } else {
    console.log("无邀请码");
    $api.user.discordLogin().then((res) => {
      console.log("discord res url;", res);
      window.location.href = res.url;
    });
  }
}

//飞机注册登录
function telegramLogin() {
  console.log("telegram login");
  const params = {
    invite: null,
    client_id: localStorage.getItem('ga4_client_id')
  };
  const invite_id = localStorage.getItem("invite_id");
  if (invite_id) {
    params.invite = invite_id;
  }
  if (params.invite) {
    console.log("有邀请码");
    $api.user.telegramLogin({ params: params }).then((res) => {
      console.log("telegram res url;", res);
      window.location.href = res.url;
    });
  } else {
    console.log("无邀请码");
    $api.user.telegramLogin().then((res) => {
      console.log("telegram res url;", res);
      window.location.href = res.url;
    });
  }
}

//登录注册成功后更新站点数据
function LoginSuccessUpdate(res) {
  localStorage.setItem("token", res.access_token);
  showNotice("s", { desc: $t("loginSuccess") });
  //登录成功更新用户数据
  const token = localStorage.getItem("token");
  if (token) {
    userStore.$patch((state) => {
      state.isToken = true;
      if (state.count <= 1) {
        state.count++;
      } else {
        state.count = 1;
      }
      //tag  更新组件key  强制重新渲染组件 显示loading?
    });
    userStore.getUserInfo().then((res) => {
      showRechargeRebateModal(userStore, $api, handleResponse);
      console.log("登录成功,更新用户数据;", res);
      isClick.value = false;
    });
  }
  //更新数据后关闭登录弹框
  emits("close");
  // resetVerify();
}

function parseUrl() {
  // 解析 URL
  const url =
    "https://api.skinroll.net/api/steam/handle?openid.ns=http%3A%2F%2Fspecs.openid.net%2Fauth%2F2.0&openid.mode=id_res&openid.op_endpoint=https%3A%2F%2Fsteamcommunity.com%2Fopenid%2Flogin&openid.claimed_id=https%3A%2F%2Fsteamcommunity.com%2Fopenid%2Fid%2F76561199650176724&openid.identity=https%3A%2F%2Fsteamcommunity.com%2Fopenid%2Fid%2F76561199650176724&openid.return_to=http%3A%2F%2Fapi.skinroll.net%2Fapi%2Fsteam%2Fhandle&openid.response_nonce=2024-12-17T07%3A24%3A59ZvV9iQpW9VO%2BboEvt2sKluic46zc%3D&openid.assoc_handle=1234567890&openid.signed=signed%2Cop_endpoint%2Cclaimed_id%2Cidentity%2Creturn_to%2Cresponse_nonce%2Cassoc_handle&openid.sig=cWayjBUfUBIlAm7H6Aw1JX39vTs%3D";
  const params = new URLSearchParams(url.split("?")[1]);

  // 获取各个参数值
  const openidNs = params.get("openid.ns");
  const openidMode = params.get("openid.mode");
  const openidOpEndpoint = params.get("openid.op_endpoint");
  const openidClaimedId = params.get("openid.claimed_id");
  const openidIdentity = params.get("openid.identity");
  const openidReturnTo = params.get("openid.return_to");
  const openidResponseNonce = params.get("openid.response_nonce");
  const openidAssocHandle = params.get("openid.assoc_handle");
  const openidSigned = params.get("openid.signed");
  const openidSig = params.get("openid.sig");

  console.log("openid.ns:", openidNs);
  console.log("openid.mode:", openidMode);
  console.log("openid.op_endpoint:", openidOpEndpoint);
  console.log("openid.claimed_id:", openidClaimedId);
  console.log("openid.identity:", openidIdentity);
  console.log("openid.return_to:", openidReturnTo);
  console.log("openid.response_nonce:", openidResponseNonce);
  console.log("openid.assoc_handle:", openidAssocHandle);
  console.log("openid.signed:", openidSigned);
  console.log("openid.sig:", openidSig);
}

// const steamLoginUrl = `https://steamcommunity.com/openid/login?openid.ns=http://specs.openid.net/auth/2.0&openid.mode=checkid_setup&openid.return_to=${encodeURIComponent(returnUrl)}&openid.realm=${encodeURIComponent(realm)}&openid.identity=http://specs.openid.net/auth/2.0/identifier_select`;
//steam登录
function steamLogin() {
  console.log("steam login");
  // parseUrl();
  // return
  //地址栏有邀请码
  const params = {
    invite: null,
    client_id: localStorage.getItem('ga4_client_id')
  };
  const invite_id = localStorage.getItem("invite_id");
  if (invite_id) {
    params.invite = invite_id;
  }
  console.log("邀请码;", params);
  if (params.invite) {
    console.log("有邀请码");
    $api.user.loginSteam({ params: params }).then((res) => {
      console.log("steam res;", res);
      window.location.href = res.url;
    });
  } else {
    console.log("无邀请码");
    $api.user.loginSteam({ params: params }).then((res) => {
      console.log("steam res;", res);
      window.location.href = res.url;
    });
  }
}

const showTeleVisible = ref(false);
onMounted(() => {
  console.log("login 组件onmounted");
  // setTimeout(() => {
  //   showTeleVisible.value = true;
  // }, 1000)
  nextTick(() => {
    showTeleVisible.value = true;
  });
  handleLoginResponse();
});

async function handleLoginResponse() {
  // 这里可以使用一个 AJAX 请求去获取 token 信息 //bug  怎么拿到token???
  const response = await fetch(window.location.href); ////bug 地址栏 这里不知道怎么写
  console.log("response;", response);
  if (response) {
    const data = await response.json();
    // 保存 token 和用户信息
    // localStorage.setItem("token", data);

    // 假设你有一个存储用户信息的变量
  } else {
    // 错误处理
  }
}

const isClick = ref(false);

function testLogin() {
  if (isClick.value) return;
  isClick.value = true;
  loginByPwdForEmail();
}

function testLogin2() {
  loginByPwdForEmail2();
}

//邮箱密码登录测试163
function loginByPwdForEmail2() {
  const admin = {
    // email: "user@example.com",
    // password: "123456",
    email: "18895239@gmail.com",
    password: "123456",
    // email: "1886853@gmail.com",
    // email: "18815526@gmail.com",
  };
  $api.user.emailLogin(admin).then((res) => {
    console.log("密码登录:", res);
    const resp = handleResponse(res);
    if (!resp) return console.log("未知错误", res.message);
    LoginSuccessUpdate(resp);
  });
}

//邮箱密码登录
function loginByPwdForEmail() {
  const admin = {
    email: "user@example.com",
    password: "123456",
  };
  $api.user.emailLogin(admin).then((res) => {
    console.log("密码登录:", res);
    const resp = handleResponse(res);
    if (!resp) return console.log("未知错误", res.message);
    LoginSuccessUpdate(resp);
  });
}

//关闭登录弹框
function close(e) {
  e.stopPropagation();
  emits("close");
  // resetVerify();
}

function toPolicy(id) {
  console.log("登录跳转协议");
  router.push(`/${route.params.lang}/policy/${id}`);
}
</script>
<style lang="scss" scoped>
//表单样式
.ant-form {
  //边框：2px 纯黄色；
  .ant-form-item {
    height: 0.88rem;
    margin-bottom: 0px;

    .ant-input {
      height: 0.5rem;
      border-radius: 0.25rem;
      background-color: #050812;
      color: #8f9eb5;
      //边框：2px 纯绿色；
    }

    .ant-input::placeholder {
      //颜色：红色！重要；
      color: #363e53 !important;
    }
  }
}

.steam-login {
  :deep(.ant-modal) {
    width: 5.2rem !important;
    min-height: 5.48rem;
    height: max-content;
    border-radius: 0.1rem;
    // border: 2px solid yellow;

    .ant-modal-content {
      min-height: 5.48rem;
      height: max-content;
      background-color: #0e121e;
      // background-image: url("@/assets/images/index/loginbgi.png");
      // @extend %clearBgi;
    }

    .ant-modal-close {
      right: 0.3rem !important;
      top: 0.3rem !important;
    }

    .ant-modal-close-x {
      width: 0.2rem !important;
      height: 0.2rem !important;

      img {
        width: 0.2rem;
        height: 0.2rem;
      }
    }

    .ant-modal-header {
      padding-top: 0.5rem;

      .ant-modal-title {
        justify-content: center;
        font-size: 0.22rem;
        font-weight: bold;
        color: #ffffff;
        font-family: "Microsoft YaHei";
      }
    }

    .ant-modal-body {
      display: flex;
      justify-content: center;

      .login-info {
        font-size: 0.2rem;
        font-weight: 400;
        margin-bottom: 0.42rem;
        margin-top: 0.38rem;
        text-align: center;
        line-height: 0.3rem;
      }

      //note 抽离按钮通用样式  宽度 背景色 icon等
      .cbtn-def {
        width: 2.7rem;
        height: 0.6rem;
        border-radius: 0.3rem;
        background-color: $active-color;
        font-size: 0.2rem;
        font-weight: bold;
        color: #ffffff;
        position: relative;
        @extend %flex-all-center;

        .btn-icon {
          position: static;
          transform: none;
          width: 0.3rem;
          height: 0.3rem;
          margin-right: 0.2rem;
        }

        .btn-txt {
          font-size: 0.2rem;
          font-weight: bold;
          color: #ffffff;
        }
      }

      .cbtn-blue {
        background-color: #0057e6;
      }

      .grayBtnSend {
        background-color: #24293b;
        font-weight: bold;
        font-size: 0.2rem;
        color: #575f72;
      }

      .verify-btn {
        z-index: 1;
        min-width: 0.9rem;
        width: max-content;
        height: 0.5rem;
        border-radius: 0.25rem;
        font-size: 0.2rem;
        font-weight: bold;
      }

      .grayBtnSend {
      }

      .ant-input-group {
        display: flex;
        position: relative;

        .verify-btn {
          position: absolute;
          right: 0;
        }
      }

      //默认
      .def-login {
        width: 4.4rem;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-content: center;
        padding-top: 0.3rem;

        .title {
          font-weight: 400;
          font-size: 0.16rem;
          color: #ffffff;
          margin-bottom: 0.1rem;
          padding-left: 0.3rem;
        }

        .email-form {
          .email-url-input {
            position: relative;

            .ant-input {
              // border: 2px solid red;
              height: 0.5rem;
              text-align: center;
              border-radius: 0.25rem;
              background-color: #050812;
              text-align: left;
              padding-left: 0.3rem;
              font-size: 0.1rem;
              font-weight: 400;

              &:hover,
              &:valid,
              &:focus {
                border: none;
                // border: 2px solid yellow;
                background-color: #050812 !important;
              }
            }

            .ant-input[disabled] {
              color: #9cabc7;
              border: none;
              border-bottom: 2px solid #272d40;
            }

            .verify-btn {
              @extend %flex-all-center;
              z-index: 1;
              border-radius: 0.25rem;
              font-size: 0.2rem;
              font-weight: bold;
              min-width: 1.2rem;
              width: max-content;
              height: 0.5rem;
              position: absolute;
              right: 0;
              bottom: 0.2rem;
            }
          }

          .unblind {
            position: relative;

            .ant-input {
              margin-bottom: 0.2rem;
            }

            .cbtn-blue {
              background-color: #0057e6;
            }

            .grayBtnSend {
              background-color: #24293b;
              font-weight: bold;
              font-size: 0.2rem;
              color: #575f72;
            }
          }
        }

        .options {
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: space-between;

          .cbtn-def {
            width: 4.4rem;
            height: 0.5rem;
            margin-bottom: 0.2rem;
          }

          .email-btn,
          .stean-btn,
          .discord-btn,
          .telegram-btn {
            background-color: #0057e6;

            .btn-icon {
              position: absolute;
              left: 6%;
              top: 50%;
              transform: translateY(-50%);
            }
          }

          .discord-btn {
            background-color: #5765f2;
          }

          .telegram-btn {
            background-color: #1f9fdf;

            .wrapper {
              width: 4.4rem;
              height: 0.5rem;
              border-radius: 0.3rem;
              @extend %flex-all-center;
              background-color: #1f9fdf;
              position: absolute;
              left: 0;
              top: 0;
              z-index: 3;
              pointer-events: none; /* 允许点击穿透 */
            }

            .telegram-login {
              border-radius: 0.25rem;
              position: absolute;
              left: 4%;
              top: 50%;
              transform: translateY(-50%);
              width: 4rem;
              height: 0.5rem;
              z-index: 0;
              overflow: hidden;

              .tgme_widget_login_button_icon {
                border: 2px solid red;
              }

              :deep(.tgme_widget_login_button_icon) {
                width: 4rem;
              }
            }
          }

          .email-btn {
            background-color: $active-color;
          }

          .reg-info {
            cursor: pointer;
            text-align: center;

            .sp1 {
              color: #343c50;
            }

            .link {
              text-decoration: underline;
              color: $active-color;
            }
          }
        }

        //协议
        .d1,
        .d2,
        .ant-checkbox-wrapper {
          color: #91a2b7;
          font-weight: 400;
          font-size: 0.16rem;
        }

        .d2 {
          .link {
            text-decoration: underline;
            font-size: bold;
          }

          .ant-checkbox-wrapper {
            line-height: 0.3rem;
          }

          .ant-checkbox-wrapper + .ant-checkbox-wrapper {
            margin: 0;
            margin-top: 0.06rem;
          }

          a {
            font-weight: 400;
            color: #91a2b7;
            border-bottom: 2px solid #91a2b7;
            // text-decoration: underline;
            // // color: #9692b8;
            // color: #fff;
          }

          .policy {
            // color: #fff;
            font-weight: bold;
            // font-size: 20px;
            text-decoration: underline;
          }
        }

        .l-w {
          position: relative;
        }

        .agreement {
          margin-bottom: 0.2rem;
        }

        .l-btn {
          position: absolute;
          left: 50%;
          transform: translate(-50%, 1.1rem);
          width: 1.8rem;
          height: 0.5rem;
          border-radius: 0.25rem;
          background-color: $active-color;
          font-size: 0.2rem;
          font-weight: bold;
        }
      }

      .devlogin {
        position: absolute;
        top: 70%;
      }
    }
  }
}
</style>
